export default class DtoJobLight {
    constructor(obj = {}) {
        this.id = obj[0]
        this.name = obj[1]
    }
}
